import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonOrder } from "shared/components/button/ButtonOrder";
import { FormCancelButton } from "shared/components/button/FormCancelButton";
import { FormSubmitButton } from "shared/components/button/FormSubmitButton";
import Form from "shared/components/form/Form";
import { FormDateInput } from "shared/components/input/date/DateInput";

export interface EqualizationEditDateModalProps {
  equalizationDate: string;
  onCloseComplete(): void;
  onSubmit: (value: string) => void;
}

interface EqualizationDateEditRequest {
  equalizationDate: string;
}

export const EqualizationEditDateModal: React.FC<
  EqualizationEditDateModalProps
> = ({ equalizationDate, onCloseComplete, onSubmit }) => {
  const { t } = useTranslation(["closing", "common"]);

  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });

  const form = useForm<EqualizationDateEditRequest>({
    defaultValues: {
      equalizationDate,
    },
  });

  const onFormSubmit = (data: EqualizationDateEditRequest) => {
    onSubmit(data.equalizationDate);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onCloseComplete={onCloseComplete}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <Form form={form} onSubmit={onFormSubmit} onSuccess={onClose}>
          <ModalHeader>
            {t("closing:editEqualizationDateModal.dateInputTitle")}
            <ModalCloseButton />
          </ModalHeader>
          <ModalBody>
            <FormDateInput
              name="equalizationDate"
              title={t("closing:editDateModal.dateInputTitle")}
            />
            <Text marginBottom={4} fontSize={14} fontWeight={400}>
              {t("closing:editEqualizationDateModal.modalBody")}
            </Text>
          </ModalBody>
          <ModalFooter gap={2}>
            <ButtonOrder
              dismiss={<FormCancelButton onClick={onClose} autoFocus={true} />}
              confirm={
                <FormSubmitButton>
                  {t("closing:editDateModal.submitBtnText")}
                </FormSubmitButton>
              }
            />
          </ModalFooter>
        </Form>
      </ModalContent>
    </Modal>
  );
};
